module.exports = __webpack_public_path__ + "img/nick-liefhebber-leaving-home.16bd391.jpg";